import { BottomSheetModal } from '@gorhom/bottom-sheet';
import React, { createContext, useState, ReactNode, useRef } from 'react';

interface ModalContextType {
  visibleName: boolean;
  input: string;
  setInput: React.Dispatch<React.SetStateAction<string>>;
  assignedStaffId: string | null;
  setAssignedStaffId: React.Dispatch<React.SetStateAction<string | null>>;
  selectedCustomerId: string | null;
  setSelectedCustomerId: React.Dispatch<React.SetStateAction<string | null>>;
  setVisibleName: React.Dispatch<React.SetStateAction<boolean>>;
  modalVisible: boolean;
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  bottomSheetHomeModalRef: React.RefObject<BottomSheetModal | null>;
  paymentModal: boolean;
  setPaymentModal: React.Dispatch<React.SetStateAction<boolean>>;
  mainModal: boolean;
  setMainModal: React.Dispatch<React.SetStateAction<boolean>>;
  filterModal: boolean;
  setFilterModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ModalContext = createContext<ModalContextType>(
  {} as ModalContextType,
);

interface ModalContextProviderObject {
  children: ReactNode;
}

export const ModalContextProvider: React.FC<ModalContextProviderObject> = ({
  children,
}) => {
  const bottomSheetHomeModalRef = useRef<BottomSheetModal | null>(null);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [visibleName, setVisibleName] = useState<boolean>(false);
  const [paymentModal, setPaymentModal] = useState<boolean>(false);
  const [mainModal, setMainModal] = useState<boolean>(false);
  const [filterModal, setFilterModal] = useState<boolean>(false);

  const [input, setInput] = useState<string>('');
  const [assignedStaffId, setAssignedStaffId] = useState<string | null>(null);
  const [selectedCustomerId, setSelectedCustomerId] = useState<string | null>(
    null,
  );

  return (
    <ModalContext.Provider
      value={{
        visibleName,
        input,
        setInput,
        assignedStaffId,
        setAssignedStaffId,
        selectedCustomerId,
        setSelectedCustomerId,
        setVisibleName,
        modalVisible,
        setModalVisible,
        bottomSheetHomeModalRef,
        paymentModal,
        setPaymentModal,
        mainModal,
        setMainModal,
        filterModal,
        setFilterModal,
      }}>
      {children}
    </ModalContext.Provider>
  );
};
